import * as React from 'react';
import { Field } from '../StatsbidragGlobals/statsbidrag.types';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
export const EMAIL_REGEX: string = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$';

export function validateFieldByRegex(validationRule: string, value: any): boolean {
  if (!value) return false;
  if (!validationRule) return true;

  let regex = new RegExp(validationRule);
  let result = regex.test(value);
  return result;
}

export function renderRadioFields(field: Field, change: any, firstRadio: boolean) {
  return (
    <div key={field.id}>
      {firstRadio && <div className="like-a-label">{field.radioHeading}</div>}
      <RadioButton
        id={field.id}
        fieldName={field.name}
        value={field.value}
        onChange={change}
        checked={field.isChecked}
        label={field.label}
      />
    </div>
  );
}

export function renderFields(fields: Field[], change: any, changeOnBlur: boolean = true) {
  let firstRadio = true;
  return fields.map((field: Field) => {
    const label = field.mandatory ? field.label + ' *' : field.label;
    if (field.type === 'radio') {
      let radioField = renderRadioFields(field, change, firstRadio);
      firstRadio = false;
      return radioField;
    }
    return (
      <div key={field.name} className="form-group-small">
        <label hidden={field.hidden} htmlFor={field.id}>
          {label}
        </label>
        <TextInput
          changeOnBlur={changeOnBlur}
          fieldName={field.name}
          placeholder={field.placeholder}
          id={field.id}
          value={field.value}
          onChange={change}
          errorMessage={field.isValid ? '' : field.errorMessage}
          hidden={field.hidden}
        />
      </div>
    );
  });
}
